
















import Vue from "vue";
import { mapState } from "vuex";
import AppHeading from "@/components/AppHeading.vue";
import MyTeamsList from "@/components/MyTeams/MyTeamsList.vue";
import Component from "vue-class-component";
import { TeamsActionTypes, TeamsState, namespaceTeams } from "@/store/teams";

@Component({
  name: "myTeamsListContainer",
  components: {
    AppHeading,
    MyTeamsList
  },
  computed: {
    ...mapState<TeamsState>(namespaceTeams, {
      teams: (state: TeamsState) => state.teams,
      paginationMeta: (state: TeamsState) => state.paginationMeta
    })
  },
  mounted() {
    this.$store.dispatch(`${namespaceTeams}/${TeamsActionTypes.FetchTeams}`);
  }
})
export default class MyTeamsListContainer extends Vue {
  onPaged(selectedPage: number) {
    this.$store.dispatch(`${namespaceTeams}/${TeamsActionTypes.FetchTeams}`, selectedPage);
  }
}
